const VhTypes = {
  DEFAULT: /** @type {const} */ ('default'),
  MEDICAL: /** @type {const} */ ('medical'),
  BRANCHING: /** @type {const} */ ('branching'),
  FREEFORM_V3: /** @type {const} */ ('freeform_v3'),
  MEDICAL_V3: /** @type {const} */ ('medical_v3'),
};

export default VhTypes;
